<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Ingreso al sistema</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form v-model="form_valid">
              <v-text-field
                label="Usuario"
                name="username"
                prepend-icon="fa fa-user"
                type="text"
                clearable
                :rules="[
                  rules.required(),
                  rules.minSize(6),
                  rules.noSpaces()
                ]"
                v-model="user"
                @keydown.enter="submit"
              ></v-text-field>
              <v-text-field
                label="Contraseña"
                name="password"
                prepend-icon="fa-lock"
                type="password"
                clearable
                :rules="[
                  rules.required(),
                  rules.minSize(6),
                  rules.noSpaces()
                ]"
                v-model="pass"
                @keydown.enter="submit"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submit">
              Ingresar
              <v-icon right>mdi-send-circle-outline</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required, minSize, noSpaces } from '@/utils/rules'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      form_valid: null,
      rules: { required, minSize, noSpaces },
      user: '',
      pass: '',
    }
  },
  methods: {
    ...mapActions('login', ['validate_user']),
    ...mapActions('snackbar', ['updateSnackbarText']),
    async submit () {
      if (this.form_valid) {
        const credentials = { username: this.user, password: this.pass }
        const logged = await this.validate_user(credentials)

        if (logged) {
          this.gotoHome()
        } else {
          this.updateSnackbarText('Nombre de usuario o contraseña inválida')
        }
      }
    },
    gotoHome () {
      this.$router.push({ name: 'Inicio' })
    },
  },
  mounted() {
    const logged = this.$store.getters['login/isLogged']

    if (logged) {
      this.gotoHome()
    }
  },
}
</script>
